import { resolveAccountCurrency } from '@/lib/currency';

/**
 * The single-currency rule for a document line account: every ledger leg of
 * an expense must be denominated in the payment account's currency (account
 * currency, org base when unset). Cross-currency movement only happens through
 * the FX clearing transfer flow. The DB's deferred balance trigger enforces the
 * same invariant; this is the client-side fail-fast, shared by the expense form
 * and the grid's line-account picker so the rule has one implementation.
 */
export function lineAccountCurrencyMatches(
  lineAccount: { currency?: string | null } | null | undefined,
  counterAccount: { currency?: string | null } | null | undefined,
  orgCurrency: string | null | undefined,
): boolean {
  return (
    resolveAccountCurrency(lineAccount, orgCurrency) ===
    resolveAccountCurrency(counterAccount, orgCurrency)
  );
}
